import { useEffect, useState } from "react";

const navLinks = [
  { href: "#new", label: "最新更新" },
  { href: "#catalog", label: "短剧合集" },
  { href: "#featured", label: "精选解读" },
  { href: "#characters", label: "人物档案" },
  { href: "#guide", label: "观看指南" },
  { href: "#faq", label: "常见问答" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-9 z-40 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50/70 backdrop-blur"
      }`}
    >
      <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-8">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
              女友的妈妈
            </span>
            <span className="mt-0.5 text-[11px] tracking-wide text-foreground-500">
              剧情演绎 · 岳母题材短剧合集
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="页面导航">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#catalog"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-play-list-2-line" aria-hidden="true" />
            开始浏览
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="展开导航菜单"
            aria-expanded={open}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-secondary-100 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-secondary-100"
              >
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}